import React, { useEffect, useState } from 'react';
import "./SpecialistFormClinics.scss"
import Dropdown from '../../../UI/Dropdown/Dropdown'
import { useSelector, useDispatch } from 'react-redux';
import { useFetching } from '../../../../hooks/useFetching';
import PostService from '../../../../API/PostService';
import { setClinicsAction } from '../../../../store/clinicsReducer';

const SpecialistFormClinics = ({ selectedClinic = null, defaultClinicItem = null, selectClinicHandler = null, errorMessage = '' }) => {
    const dispatch = useDispatch();
    const clinics = useSelector(state => state.clinics.clinics)
    const [defaultClinic, setDefaultClinic] = useState(null);
    const [clinicsList, setClinicsList] = useState([]);

    const [clinicIds, setClinicIds] = useState([]);
    const [clinicsArr, setClinicsArr] = useState([]);

    useEffect(() => {
        fetchClinics();
    }, []);

    useEffect(() => {
        if (defaultClinicItem) {
            setDefaultClinic({ ...defaultClinicItem, key: Math.random() });
        } else {
            setDefaultClinic({ ...clinics[0], key: Math.random() });
        }
    }, [selectedClinic, clinics]);

    useEffect(() => {
        let list = [];
        if (selectedClinic) {
            selectedClinic.forEach((item) => {
                const clinic = clinics.find((el) => Number(el.id) === Number(item))
                if (clinic) list.push({ ...clinic, key: Math.random() });
            })
        }

        if (defaultClinic && clinicsList.length === 0) {
            setClinicsList(list);
            setClinicsArr(list);
        }
        if (selectedClinic && clinicIds.length === 0) {
            setClinicIds(selectedClinic);
        }
    }, [defaultClinic]);

    const [fetchClinics] = useFetching(async () => {
        const response = await PostService.getClinics();
        if (response.data.success && response.data.result !== false) {
            let temp = [];
            for (let i = 0; i < response.data.result.length; i++) {
                temp.push({ ...response.data.result[i], key: Math.random() });
            }
            dispatch(setClinicsAction(temp));
        }
    });

    const selectHandler = (key, id) => {
        const clinic = clinics.find((el) => Number(el.id) === Number(id));

        if (clinic) {
            const updatedClinicsList = clinicsArr.map((el, index) => {
                if (el.key === key) {
                    return { ...clinic, key: key };
                }
                return el;
            });
            const allIds = updatedClinicsList.map(clinic => clinic.id);

            selectClinicHandler(allIds);

            setClinicsArr(updatedClinicsList);
            setClinicIds(allIds);
        }
    };

    const addClinic = () => {
        if (!defaultClinic) {
            const clinic = clinics[0];
            setDefaultClinic({ ...clinic, key: Math.random() });
        } else {
            const random = Math.random();
            setClinicsList(prevState => [...prevState, { ...defaultClinic, key: random }]);
            setClinicsArr(prevState => [...prevState, { ...defaultClinic, key: random }]);
            setClinicIds(prevState => [...prevState, defaultClinic.id]);
        }

        selectClinicHandler(clinicIds);
    };

    const removeClinic = (key) => {
        const updatedClinicsArr = clinicsArr.filter(clinic => clinic.key !== key);
        const updatedClinicIds = updatedClinicsArr.map(clinic => clinic.id);

        setClinicsList(updatedClinicsArr);
        setClinicsArr(updatedClinicsArr);
        setClinicIds(updatedClinicIds);

        selectClinicHandler(updatedClinicIds);
    };

    const sortUp = (index) => {
        if (index <= 0) return;

        const updatedClinicsList = [...clinicsList];
        const [moved] = updatedClinicsList.splice(index, 1);
        updatedClinicsList.splice(index - 1, 0, moved);

        const updatedClinicsArr = [...clinicsArr];
        const [movedArr] = updatedClinicsArr.splice(index, 1);
        updatedClinicsArr.splice(index - 1, 0, movedArr);

        const updatedClinicIds = updatedClinicsArr.map(clinic => clinic.id);

        setClinicsList(updatedClinicsList);
        setClinicsArr(updatedClinicsArr);
        setClinicIds(updatedClinicIds);

        selectClinicHandler(updatedClinicIds);
    };

    const sortDown = (index) => {
        if (index >= clinicsList.length - 1) return;

        const updatedClinicsList = [...clinicsList];
        const [moved] = updatedClinicsList.splice(index, 1);
        updatedClinicsList.splice(index + 1, 0, moved);

        const updatedClinicsArr = [...clinicsArr];
        const [movedArr] = updatedClinicsArr.splice(index, 1);
        updatedClinicsArr.splice(index + 1, 0, movedArr);

        const updatedClinicIds = updatedClinicsArr.map(clinic => clinic.id);

        setClinicsList(updatedClinicsList);
        setClinicsArr(updatedClinicsArr);
        setClinicIds(updatedClinicIds);

        selectClinicHandler(updatedClinicIds);
    };

    return (
        <div className="specialist-form-clinics">
            {clinicsList.map((clinic, index) => (
                <div key={clinic.key} className="specialist-form__clinic-selectors">
                    <div className="specialist-form__clinics-selector">
                        <Dropdown
                            optionsList={clinics}
                            optionSelected={clinic}
                            setDelButtons={clinicsList.length > 1}
                            type='clinics'
                            label='Салон'
                            sortUp={() => sortUp(index)}
                            sortDown={() => sortDown(index)}
                            handleDelete={() => removeClinic(clinic.key)}
                            selectedHandler={(id) => selectHandler(clinic.key, id)}
                            isFirst={index === 0}
                            isLast={index === clinicsList.length - 1}
                        />
                    </div>
                </div>
            ))}
            <button onClick={addClinic} className="specialist-form__clinics-button">
                <span>Добавить салон</span>
            </button>

            {errorMessage !== '' &&
                <div className="sspecialist-form-clinics__error">
                    {errorMessage}
                </div>
            }
        </div>
    );
};

export default SpecialistFormClinics;